import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import { sleep } from '@/utils/helpers';
import { EnvironmentService } from './environment.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IMapPoint } from '@/interfaces/iMapPoint';

@Injectable({
    providedIn: 'root'
})
export class AppService {
    public user: any = null;

    constructor(
      private router: Router, 
      private toastr: ToastrService,
      readonly environment: EnvironmentService,
       readonly httpClient: HttpClient) {}

       public getRandomPointsInPhx(numPoints: number): Observable<Array<IMapPoint>> {
        const params = new HttpParams().set('numPoints', numPoints.toString());
    
        return this.httpClient.get(this.environment.randomPtsPhxUrl, {
          params,
        }) as Observable<Array<IMapPoint>>;
      }

    async loginByAuth({username, password, role}) {
        try {
          console.log('username',username)
            await authLogin(username, password, role);
            await this.getProfile();
            switch (role) {
              case 'viewer':
                this.router.navigate(['/']);
                break;
              case 'editor-user':
                this.router.navigate(['/homeuserediting']);
                break;
              case 'engineer':
                this.router.navigate(['/homeeng']);
                break;
              case 'systemadmin':
                this.router.navigate(['/landing']);
                break;
                        
              default:
                break;
            }
            //this.router.navigate(['/']);
            this.toastr.success('Login success');
        } catch (error) {
            this.toastr.error(error.message);
        }
    }

    async registerByAuth({email, password, role}) {
        try {
          await authLogin(email, password, role);
          await this.getProfile();
          this.router.navigate(['/']);
          this.toastr.success('Register success');
        } catch (error) {
            this.toastr.error(error.message);
        }
    }

    async loginByGoogle() {
        try {
          this.toastr.warning('Not implemented');

        } catch (error) {
            this.toastr.error(error.message);
        }
    }

    async registerByGoogle() {
        try {
          this.toastr.warning('Not implemented');

        } catch (error) {
            this.toastr.error(error.message);
        }
    }

    async loginByFacebook() {
        try {
          this.toastr.warning('Not implemented');

        } catch (error) {
            this.toastr.error(error.message);
        }
    }

    async registerByFacebook() {
        try {

            this.toastr.warning('Not implemented');
        } catch (error) {
            this.toastr.error(error.message);
        }
    }

    async getProfile() {
        try {
            const user = await getAuthStatus();
            if(user) {
              this.user = user;
            } else {
              this.logout();
            }
          } catch (error) {
          this.logout();
            throw error;
        }
    }

    logout() {
        localStorage.removeItem('token');
        localStorage.removeItem('gatekeeper_token');
        localStorage.removeItem('authentication');
        this.user = null;
        this.router.navigate(['/login']);
    }
}


export const authLogin = (username: string, password: string, role: string) => {
  return new Promise(async (res, rej) => {
    await sleep(500);
    if (username === 'admin' && password === 'admin') {
      localStorage.setItem(
        'authentication',
        JSON.stringify({ profile: { username: 'admin', role: role } })
      );
      return res({ profile: { username: 'admin', role: role } });
    }
    return rej({ message: 'Credentials are wrong!' });
  });
};

export const getAuthStatus = () => {
  return new Promise(async (res, rej) => {
    await sleep(500);
    try {
      let authentication = localStorage.getItem('authentication');
      if (authentication) {
        authentication = JSON.parse(authentication);
        return res(authentication);
      }
      return res(undefined);
    } catch (error) {
      return res(undefined);
    }
  });
};
